<template>
  <div class="pt-2">
    <vc-share-twitter-share-icon
      :twitter-text="twitterText"
      :twitter-hash-tags="twitterHashTags"
      :src-url="srcUrl"
    ></vc-share-twitter-share-icon>

    <vc-share-hatena-share-icon
      :class="['pl-2', { [$style.isContentsAreaStyle]: this.isContentsArea }]"
      :src-url="srcUrl"
      v-if="showJapaneseWebSite"
    ></vc-share-hatena-share-icon>

    <vc-share-facebook-share-icon
      class="pl-2"
      :src-url="srcUrl"
    ></vc-share-facebook-share-icon>

    <vc-share-line-share-icon
      :class="['pl-2', { [$style.isContentsAreaStyle]: this.isContentsArea }]"
      :line-text="lineText"
      :src-url="srcUrl"
      v-if="showJapaneseWebSite"
    ></vc-share-line-share-icon>

    <vc-share-copy-url-share-icon
      class="pl-2"
      :src-url="srcUrl"
      :lang="lang"
    ></vc-share-copy-url-share-icon>
  </div>
</template>

<script>
export default {
  name: "vc-share-icons",
  props: {
    isContentsArea: {
      type: Boolean,
      default: false
    },
    twitterText: {
      type: String,
      default: ""
    },
    twitterHashTags: {
      type: String,
      default: ""
    },
    lineText: {
      type: String,
      default: ""
    },
    srcUrl: {
      type: String,
      default: ""
    },
    showJapaneseWebSite: {
      type: Boolean,
      default: true
    },
    lang: {
      type: Object,
      default: () => {
        return {
          copy_url: "URLをコピーしました。"
        };
      }
    }
  }
};
</script>

<style module>
@media screen and (max-width: 374px) {
  .isContentsAreaStyle {
    display: none;
  }
}
.shareIcon:hover {
  opacity: 0.8;
}
</style>
